"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const api_1 = require("./api");
class Client extends api_1.default {
  constructor(options) {
    super();
    this.server = {
      emit: (event, data) => {
        const listeners = this.listeners[event];
        if (listeners) {
          listeners.forEach(listener => listener(data));
        }
      }
    };
    Object.assign(this, options);
    window.addEventListener("message", _ref => {
      let {
        data
      } = _ref;
      return this.socketEvent(data);
    });
  }
  /**
   * Emits an event to the client
   * @param event Event name
   * @param data Event data
   */
  emit(event, data) {
    if (!window.parent) return false;
    const parsed = JSON.stringify({
      widgetbot: true,
      id: this.id,
      event,
      data
    });
    if (this.iframe.contentWindow) {
      this.iframe.contentWindow.postMessage(parsed, "*");
      return true;
    }
    return false;
  }
}
exports.default = Client;